<template>
  <v-row class="my-0 py-0">
    <v-col cols="12" md="9" class="py-0">
      <v-text-field
          v-model="name"
          dense
          class="rounded-r-0 rounded-l-lg"
          outlined
          label="Название"></v-text-field>
    </v-col>
    <v-col cols="12" md="3" class="py-0">
      <v-text-field
          :disabled="isShowScoreField"
          v-model="score"
          class="rounded-l-0 rounded-r-lg"
          type="number"
          step="0.5"
          outlined
          @blur="blurInput"
          @mouseup="focusInput"
          clearable
          label="Баллы"
          @focus=""
          dense
      >
      </v-text-field>
    </v-col>
  </v-row>
</template>

<script>
import {mapMutations} from "vuex";
import fieldAchievementFocusMixins from "../../mixins/fieldAchievementFocusMixins";
import {createHelpers} from "vuex-map-fields";

const {mapFields} = createHelpers({
  getterType: 'achievement_kind/getPayloadAchievementKind',
  mutationType: 'achievement_kind/updatePayloadAchievementKind',
});


export default {
  name: "AchievementKindUnitTextField",
  mixins: [fieldAchievementFocusMixins],
  props: {
    achievementUnit: Object,
    index: Number,
    unitKey: String,
  },
  data() {
    return {
      name: this.achievementUnit.name,
      score: this.achievementUnit.score
    }
  },

  computed: {
    isShowScoreField() {
      return this.achievementUnit.prtf_achievement_subunits_attributes.length > 0
    },
  },

  watch: {
    name(newValue) {
      this.updateAchievement()
    },
    score(newValue) {
      this.updateAchievement()
    },
    isShowScoreField() {
      if(this.isShowScoreField) this.score = 0.0;
    },
  },
  methods: {
    ...mapMutations({
      updateUnitData: 'achievement_kind/updateUnitData',
      deleteUnitWithAchievement: 'achievement_kind/deleteUnitWithAchievement',
    }),

    updateAchievement() {
      this.updateUnitData({
        index: this.index,
        name: this.name,
        score: this.score
      })
    },

  }
}
</script>

<style scoped>

</style>